import {MAX_UPLOAD_MB, MAX_UPLOAD_BYTES} from '@embertracking/common';

// Client side of the shared upload cap (#1279). The api enforces the same
// limit in readMultipart(); rejecting here means the user gets a friendly
// failure before any bytes leave the browser (an oversized upload would
// otherwise die at Cloud Run's opaque 32 MiB edge).
export const isOverUploadLimit = file =>
    Boolean(file) && typeof file.size === 'number' && file.size > MAX_UPLOAD_BYTES;

export const uploadLimitMessage = file =>
    `${file?.name || 'File'} exceeds the ${MAX_UPLOAD_MB} MB upload limit`;

// Guard used by the upload helpers (uploadFile/uploadImage/uploadPretripImage/
// submitStepFile) right before the request is made.
export const assertUploadWithinLimit = file => {
    if (isOverUploadLimit(file)) {
        throw new Error(uploadLimitMessage(file));
    }
};
